import { attr, customElement, FASTElement, observable } from '@microsoft/fast-element';
import { ErrorUploadGridTemplate as template } from './error-upload-grid.template';
import { ErrorUploadGridStyles as styles } from './error-upload-grid.styles';
import { ObjectValidation } from '../../../types';

const name = 'error-upload-grid';

export interface ValidationColumnConfig {
  fieldName: string;
  headerName: string;
}

@customElement({
  name,
  template,
  styles,
})
export class ErrorUploadGrid extends FASTElement {
  @attr errorProject: ObjectValidation;
  @attr columnConfigs: Array<ValidationColumnConfig>;
  @observable projectColumns: Array<ValidationColumnConfig> = [
    { fieldName: 'AVAILABLE_CAPACITY_AC', headerName: 'Available Capacity AC' },
    { fieldName: 'CITY_NAME', headerName: 'City Name' },
    { fieldName: 'COUNTY_NAME', headerName: 'County Name' },
    { fieldName: 'COUNTRY', headerName: 'Country' },
    { fieldName: 'CREATED_BY', headerName: 'Created By' },
    { fieldName: 'COD', headerName: 'COD' },
    { fieldName: 'GUARANTEED_COD', headerName: 'Guaranteed COD' },
    { fieldName: 'HUB_HEIGHT', headerName: 'Hub Height' },
    { fieldName: 'INTERCONNECTION_POINT', headerName: 'Interconnection Point' },
    { fieldName: 'INTERCONNECTION_QUEUE_ID', headerName: 'Interconnection Queue ID' },
    { fieldName: 'INTERCONNECTION_VOLTAGE', headerName: 'Interconnection Voltage' },
    { fieldName: 'ISO', headerName: 'ISO' },
    { fieldName: 'LATITUDE', headerName: 'Latitude' },
    { fieldName: 'LEGAL_NAME', headerName: 'Legal Name' },
    { fieldName: 'LONGITUDE', headerName: 'Longitude' },
    { fieldName: 'MEGAWATT_AC', headerName: 'Megawatt AC' },
    { fieldName: 'MEGAWATT_DC', headerName: 'Megawatt DC' },
    { fieldName: 'NAME', headerName: 'Name' },
    { fieldName: 'OWNER', headerName: 'Owner' },
    { fieldName: 'P50_CAPACITY_FACTOR', headerName: 'P50 Capacity Factor' },
    { fieldName: 'PANEL_TECHNOLOGY', headerName: 'Panel Technology' },
    { fieldName: 'PANEL_TYPE', headerName: 'Panel Type' },
    { fieldName: 'PANEL_MAKE_AND_MODEL', headerName: 'Panel Make And Model' },
    { fieldName: 'PROJECT_ID', headerName: 'Project Id' },
    { fieldName: 'PROJECT_OPERATOR', headerName: 'Project Operator' },
    { fieldName: 'HUB_ZONE_MATRIX_ID', headerName: 'Hub Zone Matrix ID' },
    { fieldName: 'SETTLEMENT_INDEX', headerName: 'Settlement Index' },
    { fieldName: 'SETTLEMENT_POINT', headerName: 'Settlement Point' },
    { fieldName: 'STATE_NAME', headerName: 'State Name' },
    { fieldName: 'STATE_ABBREVIATION', headerName: 'State Abbreviation' },
    { fieldName: 'TARGET_COD', headerName: 'Target COD' },
    { fieldName: 'TECHNOLOGY', headerName: 'Technology' },
    { fieldName: 'TRACKING_TYPE', headerName: 'Tracking Type' },
    { fieldName: 'TURBINE_COUNT', headerName: 'Turbine Count' },
    { fieldName: 'TYPE', headerName: 'Type' },
    { fieldName: 'TURBINE_DIAMETER', headerName: 'Turbine Diameter' },
    { fieldName: 'TURBINE_MAKE_AND_MODEL', headerName: 'Turbine Make And Model' },
    { fieldName: 'TURBINE_MEGAWATT', headerName: 'Turbine Megawatt' },
    { fieldName: 'CREATED_AT', headerName: 'Created At' },
    { fieldName: 'MODIFIED_BY', headerName: 'Modified By' },
    { fieldName: 'MODIFIED_AT', headerName: 'Modified At' },
    { fieldName: 'TICKER', headerName: 'Ticker' },
    { fieldName: 'PRICE', headerName: 'Price' },
  ];

  connectedCallBack() {
    super.connectedCallback();
  }

  public errorProjectChanged() {
    this.errorProject.fields = this.errorProject.fields.map((field) => {
      const test = this.projectColumns.find((el) => el.fieldName == field.fieldName);
      if (test) {
        field.headerName = test.headerName;
      }
      return field;
    });
  }
}
